var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/dot-notation */
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { dinapsisLateralSliderPanel } from './dinapsis-lateral-slider-panel-style';
/**
 * Represents the dinapsis-panel that open or close a div on the side
 */
let DinapsisLateralSliderPanel = class DinapsisLateralSliderPanel extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Setting the default value of the property `width` to `294px`.
         * Define the width of the panel
         */
        this.width = '294px';
        /**
         * Setting the default value of the property `height` to `calc(100vh - 52px)`.
         * Define the Height of the panel
         */
        this.height = 'calc(100vh - 52px)';
        /**
         * Setting the default value of the property `opened` to `true`.
         * Define if the panel its hiden or active
         */
        this.opened = false;
        /**
         * Setting the default value of the property `position` to left
         */
        this.position = 'left';
        /**
         * Setting the default value of the property `icon` to an empty string.
         * if its provided, provides de src for dinapsis-lateral-button
         */
        this.icon = '';
        /**
         * Setting the default value of the property `classes` to `{ hide: true, active: false }`.
         */
        this.classes = { hide: true, active: false };
    }
    /**
     * If the container is active, then set the width to 0px and hide it.
     * Otherwise, set the width and height to the width
     * and height properties and make it active.
     */
    handleClick() {
        var _a;
        this.opened = !this.opened;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-lateral-container');
        this.getPanelStyle();
        if (container) {
            if (container.className.includes('active')) {
                container.style.width = '0px';
                container.style.height = '0px';
                container.className = 'hide';
            }
            else {
                container.style.width = this.width;
                container.className = 'active';
            }
        }
    }
    /**
     * If the panel is on the left and is not opened,
     * return the left panel class. If the panel is on the
     * left and is opened, return the left panel active class.
     * If the panel is on the right and is not opened,
     * return the right panel class.
     * If the panel is on the right and is opened, return the right
     * panel active class.
     * @returns The result of the function is a string.
     */
    getPanelStyle() {
        var _a, _b;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-lateral-container');
        const containerButton = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('dinapsis-lateral-slider-panel-button');
        if (container && this.opened)
            container.style.height = this.height;
        if (this.position === 'left') {
            if (container)
                container.style.borderBottomRightRadius = '12px';
        }
        else if (container)
            container.style.borderBottomLeftRadius = '12px';
        if (this.position === 'left' && !this.opened) {
            if (container)
                container.style.width = '0px';
            if (containerButton)
                containerButton.style.left = '0';
        }
        if (this.position === 'left' && this.opened) {
            if (container)
                container.style.width = this.width;
            if (containerButton)
                containerButton.style.left = this.width;
        }
        if (this.position === 'right' && !this.opened) {
            if (container)
                container.style.width = '0px';
            if (containerButton)
                containerButton.style.right = '0';
        }
        if (this.position === 'right' && this.opened) {
            if (container)
                container.style.width = this.width;
            if (containerButton)
                containerButton.style.right = this.width;
        }
    }
    getContainerStyle() {
        if (this.position === 'left' && !this.opened) {
            return 'left-panel';
        }
        if (this.position === 'left' && this.opened) {
            return 'left-panel-active';
        }
        if (this.position === 'right' && !this.opened) {
            return 'right-panel';
        }
        if (this.position === 'right' && this.opened) {
            return 'right-panel-active';
        }
        return '';
    }
    /**
     * If the position is left, return the lateralButton function, otherwise return an empty string.
     * @returns The function lateralButton() is being returned.
     */
    isPanelLeft() {
        if (this.position === 'left') {
            return this.lateralButton();
        }
        return '';
    }
    /**
     * If the position is right, return the lateral button, otherwise return an empty string.
     * @returns The function lateralButton() is being returned.
     */
    isPanelRight() {
        if (this.position === 'right') {
            return this.lateralButton();
        }
        return '';
    }
    /**
     * It returns a dinapsis-lateral-button element with the position,
     * opened, and icon properties.
     * And click event handler that calls the handleClick method of the current component.
     * @returns The return is a function that returns a template literal.
     */
    lateralButton() {
        return html ` <dinapsis-lateral-slider-panel-button
      .position=${this.position}
      .opened=${this.opened}
      .icon=${this.icon}
      class="panel-button"
      @click="${this.handleClick}"></dinapsis-lateral-slider-panel-button>`;
    }
    /**
     * The above function is a lifecycle hook that is called when the component is first updated.
     */
    firstUpdated() {
        var _a;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-lateral-container');
        if (container)
            this.getPanelStyle();
        if (container && !this.opened) {
            container.style.width = '0px';
            container.className = 'hide';
        }
    }
    /**
     * If the panel is opened, then the panel is not hidden and is active.
     * @returns The html template is being returned.
     */
    render() {
        if (this.opened) {
            this.classes.hide = false;
            this.classes.active = true;
        }
        else {
            this.classes.hide = true;
            this.classes.active = false;
        }
        return html `
      <div class="${this.getContainerStyle()}">
        ${this.isPanelRight()}
        <span>
          <div class=${classMap(this.classes)} id="dinapsis-lateral-container">
            <slot></slot>            
          </div>
        </span>
        ${this.isPanelLeft()}
      </div>`;
    }
};
/**
 * A CSS style sheet.
 */
DinapsisLateralSliderPanel.styles = [dinapsisLateralSliderPanel];
__decorate([
    property({ type: String })
], DinapsisLateralSliderPanel.prototype, "width", void 0);
__decorate([
    property({ type: String })
], DinapsisLateralSliderPanel.prototype, "height", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisLateralSliderPanel.prototype, "opened", void 0);
__decorate([
    property({ type: String })
], DinapsisLateralSliderPanel.prototype, "position", void 0);
__decorate([
    property({ type: String })
], DinapsisLateralSliderPanel.prototype, "icon", void 0);
__decorate([
    property()
], DinapsisLateralSliderPanel.prototype, "classes", void 0);
DinapsisLateralSliderPanel = __decorate([
    customElement('dinapsis-lateral-slider-panel')
], DinapsisLateralSliderPanel);
export { DinapsisLateralSliderPanel };
//# sourceMappingURL=dinapsis-lateral-slider-panel.js.map